var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncement(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 15",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "announcement-icon",
    fill: "#fff",
    d: "M14.2 0c.4.1.7.3.8.7l3 10.7c.1.5-.2 1.1-.7 1.2-.6.1-1.1-.2-1.3-.7L13.1 1.3c-.1-.5.2-1.1.7-1.2.1-.1.3-.1.4-.1zm-2.1 1.7l.3 1.1-7.6 4.3c-.2.2-.3.5-.1.7.1.3.4.3.7.2l7.3-4.2 1.2 4.5 1 3.8h-2.7l.2.9c.1.5 0 1.1-.3 1.5-.3.4-.8.6-1.4.6h-3c-1.1 0-2.2-.8-2.5-1.8L4.9 12h.4-.9v-.1l-.7-2.5L3 7v-.1l9.1-5.2zM1.2 6.5c.4.1.7.4.8.8l1.3 4.8c.2.5-.2 1.1-.7 1.2-.6.1-1.1-.2-1.3-.7L1 11.2.2 8.3 0 7.8c-.2-.5.2-1.1.7-1.2.2-.1.3-.1.5-.1zM5.9 12l.3.9c.1.6.8 1.1 1.5 1.1h3.2c.3 0 .5-.1.6-.2.1-.1.2-.3.1-.6l-.4-1.2H5.9z"
  })));
}

export default SvgAnnouncement;